export default __webpack_public_path__ + "static/media/articleImg.aae13b77.jpg";